import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'unsubscribe',
  component: generateAsyncRouteComponent({
    loader: () => import('./components/Unsubscribe'),
  }),
};
